import React, { createContext, useContext } from 'react'
import { useAddDependentForm, UseAddDependentFormReturn } from './useAddDependentForm'

type AddDependentProviderProps = {
  children: React.ReactNode
}

type AddDependentContextProps = {
  addDependentForm: UseAddDependentFormReturn
}

const AddDependentContext = createContext<AddDependentContextProps | undefined>(undefined)

export const useAddDependent = () => {
  const context = useContext(AddDependentContext)
  if (!context) throw new Error('useAddDependent must be used within a AddDependentContext')
  return context
}

export const AddDependentProvider: React.FC<AddDependentProviderProps> = ({ children }) => {
  const form = useAddDependentForm()

  return (
    <AddDependentContext.Provider
      value={{
        addDependentForm: form,
      }}
    >
      {children}
    </AddDependentContext.Provider>
  )
}
